<!--
 * @Description: 单日浏览走势图，多个地方公用修改时需要注意
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div class="bi-tmpl-detail__right__cmpt__title">
      {{ curItem.title }}
    </div>
    <div>
      <span style="margin-top: 0" class="bi-tmpl-detail__right__cmpt__title">
        请选择图表样式
      </span>
      <span
        v-if="curItem.tips"
        style="margin-top: 0"
        class="bi-tmpl-detail__right__cmpt__tips"
      >
        {{ curItem.tips }}
      </span>
    </div>

    <Carousel ref="carouselRef" :itemHeight="1000" :itemWidth="421 + 56">
      <div
        style="width: 100%"
        v-for="(item, index) in group(TYPE_MAPPING, 3)"
        :key="index"
      >
        <div v-for="child in item" :key="child.value">
          <BaseCard
            style="
              width: 421px;
              height: 356px;
              text-align: center;
              margin-bottom: 18px;
            "
            @click="onChange(child.value)"
          >
            <component
              style="height: calc(356px - 60px)"
              :is="cmpName(child.com)"
            />
            <BaseRadio
              :value="child.value"
              :model-value="curItem.value"
            ></BaseRadio>
          </BaseCard>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleTrend from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-trend/index';

const TYPE_MAPPING = [
  {
    com: 'pc-module-trend-1',
    index: 1,
    value: '14'
  },
  {
    com: 'pc-module-trend-2',
    index: 2,
    value: '15'
  },
  {
    com: 'pc-module-trend-3',
    index: 3,
    value: '16'
  },
  {
    com: 'pc-module-trend-4',
    index: 4,
    value: '17'
  },
  {
    com: 'pc-module-trend-5',
    index: 5,
    value: '18'
  },
  {
    com: 'pc-module-trend-6',
    index: 6,
    value: '2'
  },
  {
    com: 'pc-module-trend-7',
    index: 7,
    value: '9'
  },
  {
    com: 'pc-module-trend-8',
    index: 8,
    value: '10'
  },
  {
    com: 'pc-module-trend-9',
    index: 9,
    value: '19'
  }
];

const cmpName = name => {
  return PcModuleTrend.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, group } = useDetailCmpt();
</script>
<style lang="scss"></style>
